import { render, staticRenderFns } from "./HomeForRent2.vue?vue&type=template&id=6b91a1c2&"
import script from "./HomeForRent2.vue?vue&type=script&lang=js&"
export * from "./HomeForRent2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports